<template>
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6C1 6 3.36364 1 7.5 1C11.6364 1 14 6 14 6C14 6 11.6364 11 7.5 11C3.36364 11 1 6 1 6Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.4"
    />
    <path
      d="M7.5 7.875C8.47905 7.875 9.27273 7.03553 9.27273 6C9.27273 4.96447 8.47905 4.125 7.5 4.125C6.52095 4.125 5.72727 4.96447 5.72727 6C5.72727 7.03553 6.52095 7.875 7.5 7.875Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ShowIcon',
  };
</script>

